export default "__VITE_ASSET__BqcCeToH__"